import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "../Pages/Template/Layout";
import Login from "../Pages/Authentication/Login/Login";
import ProtectedRoute from './ProtectedRoute';

const ForgotPassword = lazy(() => import("../Pages/Authentication/PasswordChanges/ForgotPassword"));
const SetNewPassword = lazy(() => import("../Pages/Authentication/PasswordChanges/SetNewPassword"));
const SetUserNewPassword = lazy(() => import("../Pages/Authentication/PasswordChanges/SetUserNewPassword"));
const SetNewUserPassword = lazy(() => import("../Pages/Authentication/PasswordChanges/SetNewUserPassword"));
const NotFoundPage = lazy(() => import("../Pages/Authentication/NotFoundPage"));
const Home = lazy(() => import("../Pages/Portal/Views/Home"));
const Resident = lazy(() => import("../Pages/Portal/Views/Resident"));
const Prospect = lazy(() => import("../Pages/Portal/Views/Prospect"));
const Owner = lazy(() => import("../Pages/Portal/Views/Owner"));
const Vendor = lazy(() => import("../Pages/Portal/Views/Vendor"));
const Application = lazy(() => import("../Pages/Portal/Views/Application"));
const Payment = lazy(() => import("../Pages/Portal/Views/Payment"));
const PastResident = lazy(() => import("../Pages/Portal/Views/PastResident"));
const Support = lazy(() => import("../Pages/Portal/Views/Support"));
const ApplicationVault = lazy(() => import("../Pages/Portal/Views/ApplicationVault"));
const UserUpload = lazy(() => import("../Pages/Portal/Views/UserUpload"));
const UserSetting = lazy(() => import("../Pages/Portal/Views/UserSettings/UserSetting"));
const User = lazy(() => import('../Pages/Portal/Views/Administrator/User'));
const Companies = lazy(() => import('../Pages/Portal/Views/Administrator/Companies'));
const Messages = lazy(() => import('../Pages/Portal/Views/Administrator/Messages'));
const AddMessage = lazy(() => import('../Pages/Portal/Views/Administrator/AddMessage'));
const EditMessage = lazy(() => import('../Pages/Portal/Views/Administrator/EditMessage'));

const routeSuspenseFallback = (
    <div className="d-flex justify-content-center align-items-center p-5" style={{ minHeight: '30vh' }}>
        <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading</span>
        </div>
    </div>
);

export default function Index() {
    return (
        <Suspense fallback={routeSuspenseFallback}>
            <Routes>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/set-new-password" element={<SetNewUserPassword />} />
                <Route path="resetPassword/:passwordChangeId?" element={<SetNewPassword />} />
                <Route path="/resetUserPassword/:passwordChangeId?" element={<SetUserNewPassword />} />
                <Route path="/notfound" element={<NotFoundPage />} />

                <Route element={<ProtectedRoute />}>
                    <Route element={<Layout />}>
                        <Route path="/portal">
                            <Route path="home" element={<Home />} />
                            <Route path="resident" element={<Resident />} />
                            <Route path="prospect" element={<Prospect />} />
                            <Route path="owner" element={<Owner />} />
                            <Route path="vendor" element={<Vendor />} />
                            <Route path="application" element={<Application />} />
                            <Route path="payment" element={<Payment />} />
                            <Route path="pastresident" element={<PastResident />} />
                            <Route path="support" element={<Support />} />
                            <Route path="document/vault" element={<ApplicationVault />} />
                            <Route path="document/userupload" element={<UserUpload />} />
                        </Route>

                        <Route path="/user">
                            <Route path="settings" element={<UserSetting />} />
                        </Route>
                        <Route path="/administrator">
                            <Route path="messages" element={<Messages />} />
                            <Route path="messages/add" element={<AddMessage />} />
                            <Route path="messages/edit/:messageId" element={<EditMessage />} />
                            <Route path="users" element={<User />} />
                            <Route path="companies" element={<Companies />} />
                        </Route>
                    </Route>
                </Route>

                <Route path="*" element={<Login />} />
            </Routes>
        </Suspense>
    );
}
